import { useUser } from '@app/context/UserContext';
import { useNavigation } from '@app/hooks/useNavigation';
import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import cx from 'classnames';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

type LogoVariantMode = 'default' | 'light';

export function Logo({
  clickable = true,
  maxWidth,
  variant = 'default',
  src,
  alt,
}: {
  clickable?: boolean;
  maxWidth?: string;
  variant?: LogoVariantMode;
  src?: string | null;
  alt?: string;
}) {
  const history = useHistory();
  const { user } = useUser();
  const { whitelabelConfig, whitelabelLoading: loading } = useUserWithCompany();
  const { navigation } = useNavigation();

  const [logoB64, setLogoB64] = useState<string | null>('unset');
  const [lightLogoB64, setLightLogoB64] = useState<string | null>(null);

  const isExternal = navigation.scope === 'quest_external';
  const isOnboardingScope = navigation.scope === 'onboarding';

  // setting the global whitelabel logo
  useEffect(() => {
    if (whitelabelConfig) {
      setLogoB64(whitelabelConfig.logoB64 || null);
      setLightLogoB64(whitelabelConfig.lightLogoB64 || null);
    }
  }, [whitelabelConfig]);

  const handleLogoClick = () => {
    !isExternal && !isOnboardingScope && clickable && history.push('/');
  };

  if (loading) {
    return null;
  }

  // decide which logo to show. An explicit `src` (e.g. a slug-resolved
  // whitelabel logo on public, unauthenticated pages) takes precedence over the
  // context-derived config.
  let chosen: string | null;
  if (src !== undefined) {
    chosen = src;
  } else if (variant === 'light') {
    chosen = lightLogoB64 || logoB64;
  } else {
    // variant === 'default' forces base logoB64
    chosen = logoB64;
  }

  return (
    <div
      className={cx(clickable && 'cursor-pointer', !maxWidth && 'max-w-[250px]')}
      style={maxWidth ? { maxWidth } : undefined}
    >
      {!chosen || chosen === 'unset' ? (
        <img
          className="max-w-full h-[70px]"
          src="/assets/images/dieter_logo.svg"
          alt="Dieter"
          onClick={handleLogoClick}
        />
      ) : (
        <img
          className="max-w-full"
          src={chosen}
          alt={alt || whitelabelConfig?.avatarName || 'Datenschutzprofi'}
          onClick={handleLogoClick}
        />
      )}
    </div>
  );
}
